import { Component, OnInit, Input } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { BotaoPrimarioComponent } from '../shared/componentes/botao-primario/botao-primario.component';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextoLinkComponent } from '../shared/componentes/texto-link/texto-link.component';

declare var bootbox: any
let acoesComponent: any;

@Component({
  selector: 'box-acoes',
  templateUrl: './box-acoes.component.html',
  styleUrls: ['./box-acoes.component.css'],
  standalone: true,
  imports: [BotaoPrimarioComponent, NgIf, FormsModule, TextoLinkComponent]
})
export class BoxAcoesComponent implements OnInit {

  @Input() roteiro;
  numeroRoteiro: string = '';
  chaveValidacao: string = '';
  showInput: boolean;
  showInputFinalizar: boolean
  idRoteiro: number;
  controlaJornadaMotorista = false;
  loading = false
  chaveDispositivoAcesso = null;


  constructor(
    private dashboardService: DashboardService,
    private boxListTruckService: BoxListTruckService,
    private boxInfoRouterService: BoxInfoRouterService
  ) {
    acoesComponent = this;
  }

  async ngOnInit() {
    this.numeroRoteiro = this.roteiro.roteiro;
    this.showInput = false;
    this.showInputFinalizar = false;
    this.idRoteiro = this.roteiro.IdRoteiro;


    this.chaveDispositivoAcesso = this.roteiro.ChaveDispositivoAcesso;
    let vetInfoRota = JSON.parse(this.roteiro.InfoRota);

    this.controlaJornadaMotorista = vetInfoRota?.ControlaJornadaMotorista ?? false
  }

  async excluirRoteiro() {
    let result = await this.dashboardService.deleteRoteiro(this.numeroRoteiro);
    return result;
  }

  loadingFinalizar = false;

  async finalizarRoteiro() {
    this.loadingFinalizar = true;
    try {
      await this.desconectarVeiculo();
      let result = await this.dashboardService.finalizarRoteiro(this.idRoteiro);
      window.location.href = window.location.href;
      return result;
    } finally {
      this.loadingFinalizar = false;
    }
  }

  mostraInputExcluir() {
    this.showInput = !this.showInput;

    if (this.showInputFinalizar) {
      this.chaveValidacao = ''
      this.showInputFinalizar = false;
    }
  }

  mostraInputFinalizar() {
    this.showInputFinalizar = !this.showInputFinalizar;

    if (this.showInput) {
      this.chaveValidacao = ''
      this.showInput = false;
    }
  }

  esconderInputFinalizar() {
    this.showInputFinalizar = false;
    this.chaveValidacao = ''
  }

  confirmarExclusaoRoteiro() {
    bootbox.dialog({
      title: 'Confirmar exclusão.',
      message: "<p>Deseja excluir o roteiro permanentemente?</p>",
      size: 'large',
      buttons: {
        cancel: {
          label: "Cancelar",
          className: 'btn-default'
        },
        ok: {
          label: "Excluir",
          className: 'btn-danger',
          callback: async function () {
            let resultado = await acoesComponent.excluirRoteiro();
            //força reload na tela
            window.location.href = window.location.href;
          }
        }
      }
    });
  }

  confirmarFinalizacaoRoteiro() {
    bootbox.dialog({
      title: 'Confirmar finalização.',
      message: "<p>Deseja finalizar o roteiro permanentemente?</p>",
      size: 'large',
      buttons: {
        cancel: {
          label: "Cancelar",
          className: 'btn-default'
        },
        ok: {
          label: "Finalizar",
          className: 'btn-success',
          callback: async function () {
            await acoesComponent.finalizarRoteiro()
            window.location.href = window.location.href;
          }
        }
      }
    });
  }

  async desconectarVeiculo() {
    this.loading = true
    await this.boxListTruckService.desconectarVeiculo(this.idRoteiro);
    this.chaveDispositivoAcesso = null
    this.loading = false;
  }
}
